<template>
  <el-container class="data-detail-wrip">
    <header>
      <i class="iconfont icon-nav-platform"></i>
      {{additionalDetail.company_name}}
      <i class="iconfont icon-close" @click="closeDialog"></i>
    </header>
    <div class="tab-box">
      <div class="tab-item" :class="(tabType == 0)?'active':''" @click="dtlChange(0)"><span>客户资料</span></div>
      <div class="tab-item" :class="(tabType == 1)?'active':''" @click="dtlChange(1)"><span>操作记录</span></div>
    </div>
    <div class="head" v-if="tabType == 0">
      <span>客户资料</span>
      <el-dropdown trigger="click" @command="handleCommand" v-if="funAuth.includes(17)">
        <span class="el-dropdown-link">
          <i class="el-icon-arrow-down el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1">删  除</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="head" v-if="tabType == 1">
      <span>操作记录</span>
    </div>
    <div class="content">
      <el-collapse v-model="activeNames" v-if="tabType == 0">
        <el-collapse-item name="1">
          <template slot="title">基本信息</template>
          <div class="form">
            <div class="item single">
              <span class="title">客户名称</span>
              <div class="item-content">{{additionalDetail.company_name}}</div>
            </div>
            <div class="item">
              <span class="title">客户姓名</span>
              <div class="item-content">{{additionalDetail.user_name}}</div>
            </div>
            <div class="item">
              <span class="title">联系电话</span>
              <div class="item-content">{{additionalDetail.phone}}</div>
            </div>
            <div class="item">
              <span class="title">增购项目</span>
              <div class="item-content" v-text="afieldInit(additionalDetail.type)"></div>
            </div>
            <div class="item" v-if="additionalDetail.type == 1">
              <span class="title">增购席位</span>
              <div class="item-content">{{additionalDetail.allow_number}}</div>
            </div>
            <div class="item" v-if="additionalDetail.type == 3">
              <span class="title">升级版本</span>
              <!-- <div class="item-content" v-text="editionInit(additionalDetail.edition)">{{additionalDetail.edition}}</div> -->
              <div class="item-content">{{additionalDetail.edition}}</div>
            </div>
            <div class="item" v-if="additionalDetail.type == 4">
              <span class="title">增购附件空间</span>
              <div class="item-content">{{additionalDetail.attachment_size}}GB</div>
            </div>
            <div class="item" v-if="additionalDetail.type == 5">
              <span class="title">增购数据上限</span>
              <div class="item-content">{{additionalDetail.data_size}}条</div>
            </div>
            <div class="item single">
              <span class="title">备注</span>
              <div class="item-content">{{additionalDetail.remark}}</div>
            </div>
            <div class="item single" v-if="additionalDetail.type == 2">
              <feature-list :featureData="featureData"></feature-list>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">系统信息</template>
          <div class="form">
            <div class="item">
              <span class="title">创建人</span>
              <div class="item-content">{{additionalDetail.create_by}}</div>
            </div>
            <div class="item">
              <span class="title">创建时间</span>
              <div class="item-content">{{additionalDetail.create_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
            </div>
            <div class="item">
              <span class="title">修改人</span>
              <div class="item-content">{{additionalDetail.modify_by}}</div>
            </div>
            <div class="item">
              <span class="title">修改时间</span>
              <div class="item-content">{{additionalDetail.modify_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div class="log-box" v-if="tabType == 1">
        <div class="log-item" v-for="(log, index) in logList" :key="index">
          <div class="line">
            <div class="circle"></div>
          </div>
          <div class="rihgt">
            <div class="time">{{log.datetime_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
            <div class="content">{{log.content}}</div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box" append-to-body>
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note" v-if="additionalDetail.type == 1">删除后该公司席位数会被自动扣除，请确保目前已使用席位数没有超过席位数上限，否者可能会出现席位异常问题。</div>
      <div class="note" v-if="additionalDetail.type == 2">删除后该公司对应的开通功能会被自动隐藏，请确保功能未被使用，否者可能会出现数据异常问题。</div>
      <div class="note" v-if="additionalDetail.type == 3">删除后该公司使用版本将回归到上一版本，请确保版本对应功能未被使用，否者会出现数据异常问题。</div>
      <div class="note" v-if="additionalDetail.type == 4">删除后该公司附件空间将被自动扣除，请确保附件空间使用量没有超过上限，否者可能会出现数据异常问题。</div>
      <div class="note" v-if="additionalDetail.type == 5">删除后该公司总数据上限将会被自动扣除，请确保数据总量没有超过上限，否者可能会出现数据异常问题。</div>
      <div class="prompt">你确定要删除该增购吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="userDelete">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import mixin from '@/common/js/mixins.js'
import {HTTPServer} from '@/common/js/ajax.js'
import featureList from '@/common/components/feature-list'// 功能清单

export default {
  props: ['additional'],
  mixins: [mixin],
  data () {
    return {
      additionalDetail: this.additional,
      activeNames: ['1', '2', '3', '4'],
      moduleId: 3,
      tabType: 0,
      dialogDelete: false
    }
  },
  components: {
    featureList
  },
  created () {
  },
  mounted () {
    console.log('增购', this.additionalDetail)
    this.queryFchBtnAuth(({moduleId: this.moduleId}))
    if (this.additionalDetail.type === 2) {
      this.queryAdditionalById()
    } else if (this.additionalDetail.type === 3) {
      // this.queryAllChargingStrategy()
    }
    // 关闭添加窗口
    this.$bus.on('closeAddModal', (value) => {
      if (value) {
        this.dialogEdit = false
      }
    })
  },
  methods: {
    // 关闭详情弹框
    closeDialog () {
      this.$bus.emit('closeAddDetailModal', true)
    },
    /** 详情导航切换 */
    dtlChange (type) {
      this.tabType = type
      if (type === 1) {
        this.queryRecordList({moduleType: this.moduleId, moduleId: this.additionalDetail.id})
      }
    },
    /** 点击菜单项触发的事件回调 */
    handleCommand (command) {
      if (command === '1') {
        this.dialogDelete = true
      }
    },
    /** 获取详情中功能清单 */
    queryAdditionalById () {
      HTTPServer.queryAdditionalById({id: this.additionalDetail.id}, 'Loading').then((res) => {
        res.map((mod) => {
          mod.funcList.map((fun) => {
            fun.choice = '1'
          })
        })
        this.featureData = {data: res, type: 1}
      })
    },
    /** 删除增购 */
    userDelete () {
      let title = this.afieldInit(this.additionalDetail.type)
      let content = ''
      if (this.additionalDetail.type === 1) {
        content = this.additionalDetail.allow_number + '个'
      } else if (this.additionalDetail.type === 2) {
        let arr = []
        this.featureData.data.map((item) => {
          item.funcList.map((fun) => {
            arr.push(fun.name)
          })
        })
        content = arr.join('、')
      } else if (this.additionalDetail.type === 3) {
        content = this.additionalDetail.edition
      } else if (this.additionalDetail.type === 4) {
        content = this.additionalDetail.attachment_size + 'GB'
      } else if (this.additionalDetail.type === 5) {
        content = this.additionalDetail.data_size + '条'
      }
      var jsondata = {'id': this.additionalDetail.id, 'accountId': this.additionalDetail.account_id, 'operatorRecord': title + content}
      console.log(jsondata)
      HTTPServer.delAdditional(jsondata, 'Loading').then((res) => {
        this.dialogDelete = false
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.$bus.emit('closeAddDetailModal', true)
        this.$bus.emit('query-additional-list', true, true)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/business/additional-detail.vue